import { Injectable } from "@angular/core";
import { IPositiveInventoryBalanceLocations } from "../interfaces/positive-inventory-balance-locations.interface";

@Injectable()
export class InventoryLocationsService {

   private positiveInventoryBalanceLocations: IPositiveInventoryBalanceLocations[] = [];
    /**
     *
     */
    constructor() {
    }

    addLocationsWithPositiveInventory(drugID: string, locationIDs: string[]): void {
        if (!locationIDs?.length)
            return;
        
        let item = this.positiveInventoryBalanceLocations.find(x => x.drugID === drugID);
        if (!item) {
            this.positiveInventoryBalanceLocations.push({drugID, locations: locationIDs});
        } else {
            item = {drugID, locations: locationIDs};
        }
    }

    getPositiveInventoryBalanceLocationIDs(drugID: string): string[] {
        return this.positiveInventoryBalanceLocations.find(x => x.drugID === drugID)?.locations;
    }
    
}